/**
 * This component just glues the redux-form and CardElement
 * implementations together
 * (basically for field-level errors)
 * https://github.com/react-bootstrap/react-bootstrap/issues/2210#issuecomment-246933578
 */
import React from 'react';
import { CardElement } from 'react-stripe-elements';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import styles from './styles.sass';

export default function FieldCardElement(props) {
  const {
    children,
    input,
    name,
    ariaLabelledBy,
    meta: { error, submitFailed, touched },
    onChange,
  } = props;

  const config = {
    style: {
      base: {
        color: '#292F36',
        // $font-family-sans-serif
        fontFamily: "'Karla', sans-serif",
        fontSize: '16px',
        '::placeholder': {
          // $input-color-placeholder
          color: 'rgba(41, 47, 54, 0.5)',
        },
      },
    },
  };
  return (
    <div className={styles.root}>
      {/* submitFailed &&
        error && <p className="text-danger text-center">{error}</p> */}
      <FormGroup
        controlId={input.name}
        validationState={touched && error ? 'error' : null}
        bsSize="large"
      >
        <span id={input.name}>{children}</span>
        <div className="form-control">
          <CardElement {...config} />
        </div>
      </FormGroup>
      {/*
      <label id={`${input.name}.value`}>
        {input.value ? 'ON' : 'OFF'}
      </label>
      */}
    </div>
  );
}
